import React, { Component } from 'react';
import {
  FaExclamationTriangle
} from 'react-icons/fa';
import { connect } from 'react-redux';
import api from '../../../axios-local-api';
import Confirm from '../../../components/UI/Confirm/Confirm';
import Modal from '../../../components/UI/Modal/Modal';
import Switch from '../../../components/UI/Switch/Switch';
import Box from '../../../hoc/Box/Box';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import * as actions from '../../../store/actions/index';
import classes from './ACDevice.css';
import AddPortAssignment from './AddPortAssignment/AddPortAssignment';
import ChangePortAssignment from './ChangePortAssignment/ChangePortAssignment';
import Success from '../../../components/UI/Success/Success';

export class ACDevice extends Component {
  constructor(props) {
    super(props);
    // console.log(this.props.originalIpRes, "this.props.originalIpRes")
    this.state = {
      adding: false,
      editing: false,
      checked: this.props.originalIpRes ? true : false,
      success: false,
      error: false,
      action: null,
      originalDevice: this.props.originalDevice,
      confirmModal: false,
      originalPortAssignment: null,
      name: '',
      internalPort: '',
      protocol: '',
      usedExternalPorts: this.props.usedExternalPorts,
    };
    this.handleToggleIpReservation = this.handleToggleIpReservation.bind(this);
  }

  componentDidMount() { }
  componentWillUpdate() { }
  componentDidUpdate(prevProps) {
    if (prevProps.originalIpRes !== this.props.originalIpRes) {
      this.setState({ checked: this.props.originalIpRes ? true : false })
    }
  }
  editPortHandler = () => {
    // this.props.onSetFromLogDetailsPage();
    this.setState({
      editing: true,
    });
  };
  addPortHandler = () => {
    // this.props.onSetFromLogDetailsPage();
    this.setState({
      adding: true,
    });
  };
  changePortHandler = (e) => {
    this.setState({
      originalPortAssignment: e,
      editing: true,
    });
  };
  modalCancelHandler = () => {
    this.setState({
      adding: false,
      editing: false,
    });
  };
  handleToggleIpReservation() {
    if (!this.state.checked) {
      this.onOpenModal('make an IP reservation', null, true);
    } else {
      this.onOpenModal('Delete this IP Reservation', null, true);
    }
  }

  getConfirmationModalForDisconnected = () => {
    return (
      <div className={classes.disconnectedModalContainer}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <FaExclamationTriangle
            id='DSAlertIcon'
            color={'red'}
            fontSize={'35px'}
            style={{ marginRight: '5px', marginTop: '8px' }} />
          <h2>Router Offline</h2>
        </div>
        <div id="RouterOfflineAlertIPResToggle" style={{ fontWeight: 600 }}>Router is offline. Configuration changes will update when router is back online.</div>
        <button
          visibility='true'
          className={classes.modalRegularButton}
          onClick={this.confirmModalCancelHandler}
          id="iprestogglealertokbutton"
        >
          OK
        </button>
      </div>
    )
  }

  successErrorResetHandler = () => {
    this.setState({ error: false, success: false });
    this.props.onResetDhcpErrorSuccess();
  };
  confirmModalConfirmHandler = () => {
    if (this.state.action === 'assign a port for port forwarding') {
      const formData = {};

      const payload = {
        formData: {
          name: this.state.name,
          internalPort: this.state.internalPort,
          externalPort: this.state.externalPort,
          protocol: this.state.protocol,
        },
      };

      // console.log('ADDING', payload, this.props.originalDevice.ip, this.props.originalDevice.mac)

      this.props.onAddPortAssignment(
        payload,
        this.props.originalDevice.ip,
        this.props.originalDevice.mac
      );
    } else if (
      this.state.action === 'remove this Port from your IP Reservations'
    ) {
      this.props.onDeletePortAssignment(
        this.props.originalDevice.ip,
        this.props.originalDevice.mac,
        this.state.originalPortAssignment.externalPort
      );
      this.confirmModalCancelHandler();
    } else if (this.state.action === 'change this IP reservation') {
      const formData = {};

      const payload = {
        formData: {
          name: this.state.name,
          internalPort: this.state.internalPort,
          protocol: this.state.protocol,
        },
      };
      // console.log('CHANGE', payload, this.props.originalDevice.ip, this.props.originalDevice.mac, this.state.originalPortAssignment.externalPort)
      this.props.onChangePortAssignment(
        payload,
        this.props.originalDevice.ip,
        this.props.originalDevice.mac,
        this.state.originalPortAssignment.externalPort
      );
    } else if (this.state.action === 'make an IP reservation') {
      this.props.onAddIpReservation(
        this.props.originalDevice.ip,
        this.props.originalDevice.mac,
        this.props.originalDevice.name.split(/\s/).join(''),
        true
      );
    } else {
      this.props.onDeleteIpReservation(this.props.originalDevice.mac);
    }
    this.closeModal();
  };

  confirmModalCancelHandler = () => {
    this.props.resetDhcp();
    this.setState({ confirmModal: false });
  };
  closeModal = () => {
    this.setState({ confirmModal: false });
  };
  onOpenModal = (action, form, isShowModal) => {
    this.modalCancelHandler();
    this.setState(
      {
        confirmModal: isShowModal,
        action: action,
        name: form ? form.name : '',
        internalPort: form ? form.internalPort : '',
        externalPort: form && form.externalPort ? form.externalPort : '',
        protocol: form ? form.protocol : '',
        originalPortAssignment:
          form && form.originalPortAssignment
            ? form.originalPortAssignment
            : null,
      },
      () => {
        if (!isShowModal) {
          this.confirmModalConfirmHandler();
        }
      }
    );
  };
  render() {
    const onOff = (
      <div className={classes.BodyInfo}>
        <Switch
          disabled={ !this.props.originalDevice.ip ||
            this.props.originalDevice.ip === 'Not Available'}
          id="IPReservationToggle"
          aria-checked={this.state.checked}
          aria-label="Toggle device IP reservation"
          onChange={this.handleToggleIpReservation}
          checked={this.state.checked}
          />
      </div>
    );

    // if (this.props.error && !this.state.error) {
    //   this.setState({ error: true })
    //   this.props.onResetDhcpErrorSuccess()
    // }
    // if (this.props.success && !this.state.success) {
    //   this.setState({ success: true })
    //   this.props.onResetDhcpErrorSuccess()
    // }
    let portForwarding;
    let portForwardList;
    let addOrEditForm;

    if (this.state.checked) {
      if (
        this.props.originalDevice.portForwards &&
        this.props.originalDevice.portForwards[0]
      ) {
        portForwardList = this.props.originalDevice.portForwards.map((el) => {
          return (
            <div className={classes.BodyRow}>
              <div
                className={classes.BodyTitle}
                style={
                  this.props.realDevices.fake && this.props.isDummy
                    ? { color: 'pink', whiteSpace: 'pre' }
                    : { whiteSpace: 'pre' }
                }
              >
                {el.name}
              </div>
              <div className={classes.BodyInfo}>
                <button
                  id="managebtn"
                  className={classes.RegularButton}
                  onClick={() => this.changePortHandler(el)}
                >
                  Manage
                </button>
              </div>
            </div>
          );
        });
      } else {
        portForwardList = <div />;
      }

      portForwarding = (
        <Box>
          <div className={classes.Header}>
            <b className={classes.IPRes}>Port Forwarding</b>
          </div>
          <div className={classes.PortForwardListStyling}>
            {portForwardList}
            <div className={classes.HeaderAreaButton}>
              <button
                id="addportbutton"
                className={classes.RegularButton}
                onClick={this.addPortHandler}
              >
                + Add Port Assignment
              </button>
            </div>
          </div>
        </Box>
      );
    } else {
      portForwarding = <div />;
    }

    if (this.state.adding) {
      addOrEditForm = (
        <AddPortAssignment
          originalPortAssignment={
            this.state.originalPortAssignment
              ? this.state.originalPortAssignment
              : null
          }
          devMac={this.props.originalDevice.mac}
          ip={this.props.originalDevice.ip}
          onSubmit={this.onOpenModal}
          onCancel={this.modalCancelHandler}
          usedExternalPorts={this.state.usedExternalPorts}
        />
      );
    } else if (this.state.originalPortAssignment && this.state.editing) {
      addOrEditForm = (
        <ChangePortAssignment
          originalPortAssignment={
            this.state.originalPortAssignment
              ? this.state.originalPortAssignment
              : null
          }
          devMac={this.props.originalDevice.mac}
          ip={this.props.originalDevice.ip}
          onSubmit={this.onOpenModal}
          onCancel={this.modalCancelHandler}
        />
      );
    }

    return (
      <Box>
        <div className={classes.BodyArea}>
          <div className={classes.InnerBodyArea}>
            {/* <div className={classes.showMobile} >
              <b className={classes.IPRes}> <FaPrint color={'black'} /> Printer</b>
            </div> */}

            <div className={classes.Header}>
              <b className={classes.IPRes}>IP Reservation</b>
            </div>

            <div className={classes.BodyRow}>
              <div className={classes.BodyTitle}>IP Address:</div>
              <div
                id="IPAddress"
                className={classes.BodyInfo}
                style={
                  this.props.realDevices.ip && this.props.isDummy
                    ? { color: 'pink' }
                    : {}
                }
              >
                {this.props.originalDevice.ip
                  ? this.props.originalDevice.ip
                  : 'Not Available'}
              </div>
            </div>

            <div className={classes.BodyRow}>
              <div className={classes.BodyTitle}>MAC Address:</div>
              <div
                id="MacAddress"
                className={classes.BodyInfo}
                style={
                  this.props.realDevices.fake && this.props.isDummy
                    ? { color: 'pink' }
                    : {}
                }
              >
                {this.props.originalDevice.mac}
              </div>
            </div>

            {/* <div className={classes.BodyRow}>
              <div className={classes.BodyTitle}>Private LAN IP Address:</div>
              <div className={classes.BodyInfo} style={this.props.realDevices.fake && this.props.isDummy ? { color: 'pink' } : {}}>
              {this.props.originalDevice.ip ? this.props.originalDevice.ip : 'Not Available'}</div>
            </div> */}

            <div className={classes.BodyRow}>
              <div id="dhcptoggle" className={classes.BodyTitle}>
                IP Reservation
              </div>
              {onOff}
            </div>

            {portForwarding}
          </div>
        </div>

        <Modal
          ipResAddDev={this.props.showOnMobile}
          show={this.state.adding || this.state.editing}
          modalClosed={this.modalCancelHandler}
        >
          {addOrEditForm}
        </Modal>
        {this.state.confirmModal && <Modal deviceNameConfirmationModal show={this.state.confirmModal} modalClosed={this.closeModal}>
          {(this.props.checkingWan || (this.props.realWan &&
            this.props.realWan.connectionState &&
            this.props.realWan.connectionState === 'disconnected') || (this.props.realWan &&
              this.props.realWan.connectionState &&
              this.props.realWan.connectionState === 'unavailable')) ? this.getConfirmationModalForDisconnected() :
            <Confirm
              id={'IPReservationConfirm'}
              action={`Are you sure you want to ${this.state.action}?`}
              confirm={this.confirmModalConfirmHandler}
              cancel={this.confirmModalCancelHandler}
              deviceGroupConfirmation
            />}
        </Modal>}
        {/* <Modal show={this.state.error} modalClosed={this.successErrorResetHandler}>
            <Error />
          </Modal>
          <Modal show={this.state.success} modalClosed={this.successErrorResetHandler}>
            <Success />
          </Modal> */}
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.dhcp.loading,
    loaded: state.dhcp.loaded,
    account: state.settings.account,
    isAuthenticated: state.auth.token !== null,
    isPinxt: state.auth.pToken !== null,
    realSettings: state.settings.realSettings,
    realDevices: state.devices.realDevices,
    isDummy: state.auth.isDummy,
    success: state.dhcp.success,
    error: state.dhcp.error,
    checkingWan: state.wan.checkingWan,
    realWan: state.wan.realWan,
   };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onResetDhcpErrorSuccess: () => dispatch(actions.resetDhcpErrorSuccess()),

    onAddIpReservation: (ip, devMac, hostName) => dispatch(actions.addIpReservation(ip, devMac, hostName, true)),
    onDeleteIpReservation: (devMac) => dispatch(actions.deleteIpReservation({ devMac, callback: () => { } })),

    onAddPortAssignment: (payload, ip, devMac) => dispatch(actions.addPortAssignment(payload, ip, devMac)),
    onChangePortAssignment: (payload, ip, devMac, externalPort) => dispatch(actions.changePortAssignment(payload, ip, devMac, externalPort)),
    onDeletePortAssignment: (ip, devMac, externalPort) => dispatch(actions.deletePortAssignment(ip, devMac, externalPort)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(ACDevice, api));
